let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iXv73")).then(() => parcelRequire('ju5RD'));